export default {"src":"/_next/static/media/hero-background-gradient-mobile.47b9aeed.svg","height":820,"width":375,"blurWidth":0,"blurHeight":0};